module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bqi7b"))).then(() => parcelRequire('3a9aZ'));